<!-- Environment bar. Renders nothing in the release build (no label). -->
<environment-banner></environment-banner>

<router-outlet></router-outlet>
